// because Fetch doesn't recognize error responses as
// actual errors since it's technically completing the response...
// import { put, call } from 'redux-saga/effects'

export const handleApiErrors = (response) => {
  // if (!response.ok) throw Error(response.statusText)

  /* if (response.meta && response.meta.code === 401) {
    throw Error('token expired')
  } else */

  if (response.meta && response.meta.code !== 200) {
    throw Error(response.meta.message)
  }
  return response
}
